// src/App.js
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Products from "./components/Products";
import Strengths from "./components/Strengths";
import Footer from "./components/Footer";
import './globals.css'
import Vision from "./components/Vision";
function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Vision/>
      <Products />
      <Strengths />
      <Footer />
    </div>
  );
}

export default App;
